module.exports = __webpack_public_path__ + "static/stores-053496df234c782907b06511e24b91f9.png";